module.exports = __webpack_public_path__ + "d5ac1ab34ea77a9d4612b9e6402c5418.png";